import TextValue from "./TextValue/TextValue";
import NumberValue from "./NumberValue/NumberValue";
import EmailArrayValue from "./EmailArrayValue/EmailArrayValue";
import DateRangeValue from "./DateRangeValue/DateRangeValue";
import DateValue from "./DateValue/DateValue";
import DateFullValue from "./DateFullValue/DateFullValue";
import CampaigsValue from "./CampaigsValue/CampaigsValue";
import NumberRangeValue from "./NumberRangeValue/NumberRangeValue";
import DayValue from "./DayValue/DayValue";
import AudiencesValue from "./AudiencesValue/AudiencesValue";
import { ConditionInput, SegmentConditionsInfo } from "../../EditSegment.types";
import DateRangeFullValue from "./DateRangeFullValue/DateRangeFullValue";
import TextArrayValue from "./DomainArrayValue/DomainArrayValue";
import PercentValue from "./PercentValue/PercentValue";
import PercentRangeValue from "./PercentRangeValue/PercentRangeValue";
import FrequencyRangeValue from "./FrequencyRangeValue/FrequencyRangeValue";
import ISPArrayValue from "./ISPArrayValue/ISPArrayValue";
import WorkflowsValue from "./WorkflowValue/WorkflowValue";
import SenderDetailsValue from "./SenderDetailsValue/SenderDetailsValue";
import CustomTextArrayValue from "./CustomTextArrayValue/CustomTextArrayValue";
import BooleanValue from "./BooleanValue/BooleanValue";

function NoValue() {
  return null;
}

const componentValueMap: { [key in ConditionInput]: any } = {
  AUDIENCE_ARRAY: AudiencesValue,
  TEXT_ARRAY: ISPArrayValue,
  TEXT: TextValue,
  NULL: NoValue,
  EMAIL_ARRAY: EmailArrayValue,
  DAY: DayValue,
  DATE: DateValue,
  DATE_FULL: DateFullValue,
  DATE_RANGE: DateRangeValue,
  DATE_RANGE_FULL: DateRangeFullValue,
  NUMBER: NumberValue,
  NUMBER_RANGE: NumberRangeValue,
  CAMPAIGN_ARRAY: CampaigsValue,
  DOMAIN_ARRAY: TextArrayValue,
  PERCENT: PercentValue,
  PERCENT_RANGE: PercentRangeValue,
  FREQUENCY_RANGE: FrequencyRangeValue,
  WORKFLOW_ARRAY: WorkflowsValue,
  SENDER_ARRAY: SenderDetailsValue,
  CUSTOM_TEXT_ARRAY: CustomTextArrayValue,
  BOOLEAN: BooleanValue,
};

export function getConditionValueComponent(
  segmentConditionsInfo: SegmentConditionsInfo | undefined,
  attributeType: string,
  attributeName: string,
  criteria: string
) {
  if (!attributeType || !attributeName || !criteria) {
    return NoValue;
  }
  const attrType = segmentConditionsInfo?.attributesTypes?.[attributeType];
  const attrName = attrType?.attributes?.find(
    (attr) => attr.name === attributeName
  );
  const input = attrName?.criteria[criteria].input;
  const component = componentValueMap[input!];
  return component || NoValue;
}

export function getConditionValueType(
  segmentConditionsInfo: SegmentConditionsInfo | undefined,
  attributeType: string,
  attributeName: string,
  criteria: string
) {
  if (!attributeType || !attributeName || !criteria) {
    return null;
  }
  const attrType = segmentConditionsInfo?.attributesTypes?.[attributeType];
  const attrName = attrType?.attributes?.find(
    (attr) => attr.name === attributeName
  );
  return attrName?.type as string;
}

export function getEmptyValue(
  segmentConditionsInfo: SegmentConditionsInfo | undefined,
  attributeType: string,
  attributeName: string,
  criteria: string
) {
  const attrType = segmentConditionsInfo?.attributesTypes?.[attributeType];
  const attrName = attrType?.attributes?.find(
    (attr) => attr.name === attributeName
  );
  const type = attrName?.type;
  const isArray = type?.endsWith("[]");
  const input = attrName?.criteria[criteria].input;
  switch (input) {
    case "AUDIENCE_ARRAY": {
      return {
        type,
        value: [],
      };
    }
    case "TEXT_ARRAY": {
      return {
        type,
        value: [],
      };
    }
    case "EMAIL_ARRAY": {
      return {
        type,
        value: [],
      };
    }
    case "CAMPAIGN_ARRAY":
    case "SENDER_ARRAY":
    case "WORKFLOW_ARRAY": {
      return {
        type,
        value: [],
      };
    }
    case "DOMAIN_ARRAY":
    case "CUSTOM_TEXT_ARRAY": {
      return {
        type,
        value: [],
      };
    }
    case "BOOLEAN": {
      return {
        type,
        value: null,
      };
    }
    case "TEXT": {
      return {
        type,
        value: isArray ? [""] : "",
      };
    }
    case "PERCENT_RANGE":
    case "FREQUENCY_RANGE":
    case "NUMBER_RANGE": {
      return {
        type,
        value: [null, null],
      };
    }
    case "PERCENT":
    case "NUMBER": {
      return {
        type,
        value: isArray ? [null] : null,
      };
    }
    case "DAY": {
      return {
        type,
        value: isArray ? [null] : null,
      };
    }
    case "DATE_RANGE":
    case "DATE_RANGE_FULL": {
      return {
        type,
        value: [null, null],
      };
    }
    case "DATE":
    case "DATE_FULL": {
      return {
        type,
        value: isArray ? [null] : null,
      };
    }
  }
  return undefined;
}

interface Option {
  label: string;
  value: string;
}

export function compareOptions(optionA: Option, optionB: Option) {
  return optionA.label.localeCompare(optionB.label);
}
